<template>
  <svg
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M38.1872 13.1348L27.1703 11.518L22.2454 1.43617C22.1109 1.16014 21.8896 0.936683 21.6162 0.800856C20.9307 0.459098 20.0976 0.743896 19.7548 1.43617L14.8299 11.518L3.81297 13.1348C3.50924 13.1786 3.23154 13.3232 3.01892 13.5423C2.76188 13.8091 2.62024 14.168 2.62512 14.5401C2.63 14.9123 2.78101 15.2673 3.04496 15.5271L11.0159 23.3744L9.13269 34.4552C9.08853 34.713 9.11678 34.9781 9.21423 35.2205C9.31168 35.4628 9.47444 35.6728 9.68405 35.8265C9.89366 35.9803 10.1417 36.0716 10.4001 36.0902C10.6585 36.1088 10.9169 36.0539 11.146 35.9318L21.0001 30.7003L30.8541 35.9318C31.1232 36.0764 31.4356 36.1246 31.735 36.072C32.49 35.9406 32.9977 35.2176 32.8675 34.4552L30.9843 23.3744L38.9552 15.5271C39.1722 15.3124 39.3154 15.032 39.3588 14.7253C39.4759 13.9585 38.9465 13.2487 38.1872 13.1348V13.1348Z"
      fill="currentColor"
    />
  </svg>
</template>
